"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var clsx_1 = __importDefault(require("clsx"));
var react_redux_1 = require("react-redux");
var moderationNoteSlice_1 = require("@features/ItemCommon/state/moderationNoteSlice");
var _store_1 = require("@store");
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var moderationNotes_1 = require("@features/ItemCommon/service/moderationNotes");
var CHARACTER_LIMIT = 2000;
function CreateNote(props) {
    var job = props.job, domain = props.domain, documentId = props.documentId, updateModerationNotes = props.updateModerationNotes;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = __read(react_1.default.useState(''), 2), value = _a[0], setValue = _a[1];
    var dispacth = (0, _store_1.useAppDispatch)();
    var status = (0, react_redux_1.useSelector)(moderationNoteSlice_1.loadingSelector);
    var isCharacterLimitReached = value.length > CHARACTER_LIMIT;
    var isDisableClear = !value || status === 'loading';
    var submitNote = function () {
        if (!isCharacterLimitReached && value.length > 0) {
            dispacth((0, moderationNoteSlice_1.publishNote)({ domain: domain, documentId: documentId, noteContentText: value })).then(function () {
                if (status === 'idle') {
                    clearNote();
                    (job === null || job === void 0 ? void 0 : job.ad) &&
                        (0, moderationNotes_1.fetchModerationNotes)(domain, job.ad).then(function (notes) {
                            if (notes) {
                                updateModerationNotes(notes);
                            }
                        });
                }
            });
        }
    };
    var clearNote = function () {
        if (isDisableClear) {
            return;
        }
        setValue('');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_textarea_autosize_1.default, { className: "moderation-notes__create-note__text-area", placeholder: t('ITEM.MODERATION_NOTES.INPUT_PLACEHOLDER'), "data-cy": "moderation-note-input", value: value, onChange: function (e) { return setValue(e.target.value); }, minRows: 2 }),
        react_1.default.createElement("div", { className: "moderation-notes__create-note__control" },
            react_1.default.createElement("div", { className: (0, clsx_1.default)({
                    'moderation-notes__create-note__character-count': true,
                    'moderation-notes__create-note__character-count--invalid': isCharacterLimitReached,
                    'moderation-notes__create-note__character-count--close-to-limit': value.length > CHARACTER_LIMIT - 100 && CHARACTER_LIMIT >= value.length,
                }) },
                value.length || 0,
                "/",
                t('ITEM.MODERATION_NOTES.CHARACTERS_REACT', { COUNT: CHARACTER_LIMIT })),
            react_1.default.createElement("div", { className: "moderation-notes__create-note__icons-container" },
                react_1.default.createElement("i", { "data-cy": "moderation-note-submit", className: (0, clsx_1.default)({
                        'moderation-notes__create-note__icon implioicons-paper-plane': true,
                        'moderation-notes__create-note__icon--disabled': isCharacterLimitReached || !value || status === 'loading',
                    }), title: isCharacterLimitReached
                        ? t('ITEM.MODERATION_NOTES.CHARACTER_LIMIT_REACHED_TOOLTIP')
                        : t('ITEM.MODERATION_NOTES.SUBMIT_ICON_TOOLTIP'), onClick: submitNote }),
                react_1.default.createElement("i", { "data-cy": "moderation-note-cancel", className: (0, clsx_1.default)({
                        'moderation-notes__create-note__icon implioicons-cross': true,
                        'moderation-notes__create-note__icon--disabled': !value || status === 'loading',
                    }), title: t('ITEM.MODERATION_NOTES.CLEAR_TEXT_ICON_TOOLTIP'), onClick: clearNote })))));
}
exports.default = CreateNote;
